import React, { useContext } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { usePageClassName } from '../hooksInternal/usePageClassName';
import { Context as ConfigContext } from '../Config';
import WithTitle from '../componentsInternal/WithTitle';
import { Helmet } from '../components/meta';
const Error401Page = () => {
    var _a;
    const { t } = useTranslation();
    usePageClassName('error-page');
    const { pages } = useContext(ConfigContext);
    const title = t('pageTitles.error401') || t('pageTitles.error');
    const Page = ((_a = pages.error401) === null || _a === void 0 ? void 0 : _a.component) || pages.error.component;
    return (React.createElement(WithTitle, { title: title },
        React.createElement(Helmet, null,
            React.createElement("meta", { name: "robots", content: "noindex" })),
        React.createElement(Page, null)));
};
Error401Page.displayName = 'Error401Page';
export default Error401Page;
//# sourceMappingURL=error401.js.map